enum DeeplinkType {
  AREA_LOGADA = 'areaLogada',
  OFERTA = 'oferta',
  CAPTACAO = 'captacao',
}

export default DeeplinkType;
